export const ifNull = (val) => {
    return !(/^\s*$/).test(val) && val !== '' && val !== null && val !== undefined
}